"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import IconArrowRight from 'cccisd-icons/arrow-right2';
// import { getIsEmpty } from 'cccisd-laravel-flow/dist/selectors/builder';
// import _isNil from 'lodash/isNil';
var SingleFlow = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(SingleFlow, _React$Component);
  function SingleFlow() {
    var _this;
    _classCallCheck(this, SingleFlow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SingleFlow, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      pawnId: 0,
      pawnHash: 0,
      showReadOnly: false,
      showReportNode: false
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.examineProps(_this.props);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      _this.examineProps(nextProps);
    });
    _defineProperty(_assertThisInitialized(_this), "examineProps", function (props) {
      var pawnId = props.pawn.pawn.pawnId;
      var pawnHash = props.pawn.pawn.pawnHash;
      var showReadOnly = false;
      var showReportNode = props.showReport;
      if (props.progress.completed && !props.showReport) {
        showReadOnly = true;
      }
      _this.setState({
        pawnId: pawnId,
        pawnHash: pawnHash,
        showReadOnly: showReadOnly,
        showReportNode: showReportNode
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onFlowComplete", function () {
      _this.props.onFlowComplete({
        handle: _this.props.handle,
        flowHandle: _this.props.flowHandle,
        responseSet: _this.props.responseSet
      });
      _this.props.onActivityFinished({
        handle: _this.props.handle,
        flowHandle: _this.props.flowHandle,
        responseSet: _this.props.responseSet
      });
    });
    _defineProperty(_assertThisInitialized(_this), "editSurvey", function () {
      _this.setState({
        showReadOnly: false,
        showReportNode: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onDone", function () {
      _this.props.onDone({
        handle: _this.props.handle,
        flowHandle: _this.props.flowHandle,
        responseSet: _this.props.responseSet
      });
    });
    _defineProperty(_assertThisInitialized(_this), "flowVarDataCheck", function (props) {
      var hasFlowVarData = !(0, _isNil2["default"])(props.flowVarData);
      if (hasFlowVarData) {
        if (!(0, _isEmpty2["default"])(Object.keys(props.flowVarData)[0])) {
          return props.flowVarData;
        }
      }
    });
    return _this;
  }
  _createClass(SingleFlow, [{
    key: "render",
    value: function render() {
      var flowVarData = this.flowVarDataCheck(this.props);
      if (this.props.loading) {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }
      if (this.state.showReadOnly) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: this.props.handle
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].buttonContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '5px'
          }
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          onClick: this.editSurvey,
          className: "btn btn-primary btn-sm"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], {
          spaceRight: true
        }), "Edit"))), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            minHeight: '100px'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.flowVariables && !flowVarData,
          removeChildren: true
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, {
          responseSet: this.props.responseSet,
          pawnId: this.state.pawnId,
          handle: this.props.flowHandle,
          pawnHash: this.state.pawnHash,
          userLists: this.props.acrossChildren && 'formattedFlowUserLists' in this.props.acrossChildrenSettings ? this.props.acrossChildrenSettings.formattedFlowUserLists : {},
          isPrintMode: true,
          variables: flowVarData
        }))));
      }
      if (this.state.showReportNode) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].buttonContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '5px'
          }
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          onClick: this.editSurvey,
          className: "btn btn-primary btn-sm"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], {
          spaceRight: true
        }), "Edit"))), this.props.reportNode, this.props.reportNode ? /*#__PURE__*/_react["default"].createElement("div", null) : /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            minHeight: '100px'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, {
          responseSet: this.props.responseSet,
          pawnId: this.state.pawnId,
          handle: this.props.flowHandle,
          pawnHash: this.state.pawnHash,
          userLists: this.props.acrossChildren && 'formattedFlowUserLists' in this.props.acrossChildrenSettings ? this.props.acrossChildrenSettings.formattedFlowUserLists : {}
        })));
      }
      if (this.props.acrossChildren && 'formattedFlowUserLists' in this.props.acrossChildrenSettings) {
        var userLists = this.props.acrossChildrenSettings.formattedFlowUserLists;
        if (userLists.group_session_fidelity_participants) {
          userLists.group_session_fidelity_participants = userLists.group_session_fidelity_participants.map(function (user) {
            return _objectSpread(_objectSpread({}, user), {}, {
              name: user.name.toString()
            });
          });
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: this.props.handle
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.flowVariables && !this.props.flowVarData,
          removeChildren: true
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, _extends({
          onComplete: this.onFlowComplete,
          pawnId: this.state.pawnId,
          userLists: userLists,
          pawnHash: this.state.pawnHash,
          handle: this.props.flowHandle
        }, (0, _omit2["default"])(this.props, ['handle']), {
          variables: this.props.flowVarData
        }))));
      }

      // if (this.props.flowVariables) {
      //     console.log(this.props);
      //     return (
      //         <Player
      //             onComplete={this.onFlowComplete}
      //             pawnId={this.state.pawnId}
      //             pawnHash={this.state.pawnHash}
      //             handle={this.props.flowHandle}
      //             {..._omit(this.props, ['handle'])}
      //             variables={this.props.flowVarData}
      //         />
      //     );
      // }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.handle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.props.flowVariables && !this.props.flowVarData,
        removeChildren: true
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, _extends({
        onComplete: this.onFlowComplete,
        pawnId: this.state.pawnId,
        pawnHash: this.state.pawnHash,
        handle: this.props.flowHandle
      }, (0, _omit2["default"])(this.props, ['handle']), {
        variables: this.props.flowVarData
      }))));
    }
  }]);
  return SingleFlow;
}(_react["default"].Component);
_defineProperty(SingleFlow, "propTypes", {
  handle: _propTypes["default"].string,
  flowHandle: _propTypes["default"].string,
  responseSet: _propTypes["default"].number,
  onFlowComplete: _propTypes["default"].func,
  childList: _propTypes["default"].array,
  acrossChildren: _propTypes["default"].bool,
  acrossChildrenSettings: _propTypes["default"].object,
  pawn: _propTypes["default"].object,
  goToNextActivity: _propTypes["default"].func,
  progress: _propTypes["default"].object,
  onDone: _propTypes["default"].func,
  showNextButton: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  onActivityFinished: _propTypes["default"].func,
  reportNode: _propTypes["default"].node,
  showReport: _propTypes["default"].bool,
  flowVariables: _propTypes["default"].bool,
  flowVarData: _propTypes["default"].object
});